<script setup>
import { storeToRefs } from "pinia";
import { useToastsStore } from "../stores/toasts";
import Icon from "./Icon.vue";

const toastsStore = useToastsStore();
const { toasts } = storeToRefs(toastsStore);
</script>

<template>
  <TransitionGroup
    name="toasts"
    tag="div"
    class="pointer-events-none fixed inset-4 z-50 flex flex-col items-end justify-end gap-4"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="pointer-events-auto relative w-full max-w-xs overflow-hidden rounded bg-white px-5 py-4 shadow"
      :class="[toast.pos === 'left' && 'self-start']"
      :style="{ '--enter-from': toast.pos === 'left' ? '-2rem' : '2rem' }"
    >
      <div
        :class="[
          'absolute left-0 top-0 h-full w-1',
          {
            'bg-blue-600': ['info', 'success'].includes(toast.type),
            'bg-red-600': toast.type === 'error',
          },
        ]"
      ></div>

      <button
        @click="toastsStore.remove(toast.id)"
        type="button"
        class="absolute right-2 top-2 transition-colors hover:text-blue-600"
      >
        <span class="sr-only">Close</span>
        <Icon name="close" class="h-4 w-4" />
      </button>

      <h3 class="mr-3 leading-tight">
        {{ toast.title }}
      </h3>

      <p
        v-if="toast.description"
        class="mt-1 text-sm leading-tight text-gray-500"
      >
        {{ toast.description }}
      </p>
    </div>
  </TransitionGroup>
</template>

<style scoped>
.toasts-enter-active {
  transition: all 0.3s ease 0.15s;
}
.toasts-move,
.toasts-leave-active {
  transition: all 0.3s ease;
}
.toasts-enter-from,
.toasts-leave-to {
  opacity: 0;
  transform: translateX(var(--enter-from));
}
</style>
